export const PROVIDER_ROLE_OPTIONS = [
  { value: 'doctor', label: 'Doctor' },
  { value: 'specialist', label: 'Specialist' },
  { value: 'therapist', label: 'Therapist' },
  { value: 'nurse', label: 'Nurse' },
  { value: 'clinic', label: 'Clinic / Practice' },
  { value: 'other', label: 'Other' },
];

export const PROVIDER_ROLE_VALUES = PROVIDER_ROLE_OPTIONS.map((option) => option.value);

export const PROVIDER_SOURCE_KINDS = ['manual', 'extracted', 'imported', 'migrated', 'system'];

export const PROVIDER_SOURCE_KIND_OPTIONS = [
  { value: 'manual', label: 'Manual' },
  { value: 'extracted', label: 'Extracted' },
  { value: 'imported', label: 'Imported' },
  { value: 'migrated', label: 'Migrated' },
  { value: 'system', label: 'System' },
];

export const getProviderRoleLabel = (role = '') => (
  PROVIDER_ROLE_OPTIONS.find((option) => option.value === role)?.label || 'Other'
);
